import React from 'react';
import Navbar from './components/navbar.js';
import Footer from './components/footer.js';
import Home from './pages/home.js';
import Portfolio from './pages/portfolio.js';
import About from './pages/about.js';
import Contact from './pages/contact.js';

export default function App() {

  let component;
  switch(window.location.pathname) {
    case '/':
      component = <Home />;
      break;
    case '/portfolio':
      component = <Portfolio />;
      break;
    case '/about':
      component = <About />;
      break;
    case '/contact':
      component = <Contact />
      break;
    default:
      component = <Home />;
      break;
  }

return (
  <body>
    <Navbar />
    {component}
    <Footer />
  </body>
);
}